export const JACKPOTS_CASINO_FETCH = 'JACKPOTS_CASINO_FETCH';
export const JACKPOTS_BINGO_FETCH = 'JACKPOTS_BINGO_FETCH';

export const fetchCasinoJackpot = casinoJackpots => ({
    type: JACKPOTS_CASINO_FETCH,
    payload: casinoJackpots
});

export const fetchBingoJackpot = vfJackpots => ({
    type: JACKPOTS_BINGO_FETCH,
    payload: vfJackpots
});
